import { Splide } from '@splidejs/splide';
import '@splidejs/splide/css/core';

class BusinessSlides {
  constructor(el) {
    this.dom = {el: el};
    this.dom.slider = this.dom.el.querySelector('.splide');
    this.dom.controller = this.dom.el.querySelector('.splide-controller');

    this.slider = null;
    this.option = {
      perPage: 1,
      pagination: false,
      type: 'loop',
      speed: 1200,
      arrows: (this.dom.controller) ? true : false,
    };

    this.init();
  }

  init() {
    this.slider = new Splide(this.dom.slider, this.option);
    this.slider.mount();
  }
}

export default BusinessSlides